import React, { useState, useEffect, useContext, ChangeEvent, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useNcmTextoPendente, MENSAGEM_NCM_INEXISTENTE } from '../../../../hooks/useNcmTextoPendente'
import NcmErroCampo from '../../../NcmErroCampo'
import ApiService from '../../../../services/ApiService'
import AttachmentApiService from '../../../../services/AttachmentApiService'
import AttachmentSourceModal from '../../../../components/AttachmentSourceModal'
import AttachmentGalleryModal, { GalleryFile } from '../../../../components/AttachmentGalleryModal'
import openSignedAttachment from '../../../../utils/openSignedAttachment'
import { validateToken } from '../../../../utils/tokenValidation'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  InputRowDiv,
  InputDiv,
  InputLabel,
  Input,
  SwitchesDiv,
  SwitchDiv,
  SwitchLabel,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  FilesDiv,
  FileBlockDiv,
  FileHeaderText,
  FileInputDiv,
  FileInputLabel,
  FileInput,
  FilesInfoDiv,
  FileInfoDiv,
  FileInfoImg,
  FileMiddleDiv,
  FileUpperMiddleDiv,
  FileName,
  FilePercentage,
  FileInfoCancelImg,
  ProgressContainer,
  ProgressFill,
  FileFirstText,
  FileSecondText,
  ButtonsDiv,
  WarningDiv,
  WarningText,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import StockContext, { Stock } from '../../../../contexts/StockContext'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import { useTenant } from '../../../../contexts/TenantContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowLeft from '../../../../assets/addStockModal/pages/arrow-left.svg'
import fileIcon from '../../../../assets/addStockModal/pages/file.svg'
import cancelIcon from '../../../../assets/addStockModal/pages/cancel.svg'
import diskIcon from '../../../../assets/addStockModal/pages/disk.svg'
import StockDropdown from '../StockDropdown'
import {
  FieldsToHeaders,
  fieldsToHeaders,
} from '../../../../pages/ClientPanel/Stock/StockTable/utils'
import UserContext from '../../../../contexts/UserContext'
import { Info } from 'lucide-react'
import LoadingComponent from '../../../../components/LoadingComponent'
import ConfirmationModal from '../../../../components/ModalConfirmation'
import InfiniteSelect from '../../../InfiniteSelect'

export interface ProgressBar {
  completion: number
}

const LoadingButtonContent: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <span
        style={{
          fontSize: 'inherit',
          fontWeight: 'inherit',
        }}
      >
        Aguarde...
      </span>
    </div>
  )
}

const ThirdCustomAddPage: React.FC = () => {
  console.log('🚀 [THIRDPAGE] Componente ThirdCustomAddPage carregado');

  const { setModalActive, setModalSection, itIsUpdate, stockMode, isVariation } =
    useContext(ModalContext)
  const { stock, setStock, setRefresh } = useContext(StockContext)
  const { token } = useContext(UserContext)
  const { setFeedback } = useContext(FeedbackContext)
  const { isFashionTenant } = useTenant()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get('returnTo')

  const handleCloseModal = () => {
    setModalActive(false)
    if (returnTo) {
      navigate(returnTo, { replace: true })
    }
  }

  const [isSourceChoiceOpen, setIsSourceChoiceOpen] = useState(false)
  const [isGalleryOpen, setIsGalleryOpen] = useState(false)
  const [pendingFileType, setPendingFileType] = useState<'invoice' | 'certificate' | 'general'>('invoice')

  const invoiceInputRef = useRef<HTMLInputElement>(null)
  const certificateInputRef = useRef<HTMLInputElement>(null)
  const generalInputRef = useRef<HTMLInputElement>(null)

  const handleOpenSourceChoice = (type: 'invoice' | 'certificate' | 'general') => {
    setPendingFileType(type)
    setIsSourceChoiceOpen(true)
  }

  const handleSelectFromGallery = (galleryFiles: GalleryFile[]) => {
    if (!galleryFiles || !galleryFiles.length) return
    const file = galleryFiles[0]
    if (!file?.fileUrl) return

    if (pendingFileType === 'invoice') {
      setStock((prev) => ({ ...prev, externalInvoiceUrl: file.fileUrl }))
    } else if (pendingFileType === 'certificate') {
      setStock((prev) => ({ ...prev, externalCertificateUrl: file.fileUrl }))
    } else {
      setStock((prev) => {
        const current = prev.attachments || []
        const newAttachments = galleryFiles
          .filter((gf) => gf.fileUrl && !current.some((c: any) => c.fileUrl === gf.fileUrl))
          .map((gf) => ({
            id: gf.id,
            title: gf.originalName || gf.title || gf.fileName,
            fileUrl: gf.fileUrl,
          }))
        return {
          ...prev,
          attachments: [...current, ...newAttachments],
        }
      })
    }
  }

  const getSelectValue = (fieldId: number | undefined, fieldName: string | undefined) => {
    if (fieldId !== undefined && fieldId !== null) {
      return { id: fieldId, name: fieldName || '' }
    }
    if (fieldName) {
      return { id: fieldName, name: fieldName }
    }
    return null
  }

  const handleSelectChange = (option: any, fieldIdName: string, fieldName: string) => {
    setStock(prev => ({
      ...prev,
      [fieldIdName]: option ? option.id : undefined,
      [fieldName]: option ? option.name : '',
    }))
  }

  const handleSelectNcm = (option: any) => {
    ncmTexto.limpar()
    if (!option) {
      setStock(prev => ({ ...prev, ncmId: undefined, ncm: '' }))
      return
    }
    setStock(prev => ({ ...prev, ncmId: option.id, ncm: option.ncm ?? option.name }))
  }

  const isFashion = Boolean(isFashionTenant || stockMode === 'fashion')
  const isCodeRequired = !isFashion

  const getHeaderTitle = () => {
    if (isVariation) return isFashion ? 'Criar Variação de Tecido' : 'Criar Variação de Estoque'
    if (isFashion) return itIsUpdate ? 'Editar Tecido' : 'Adicionar Tecido'
    return itIsUpdate ? 'Editar Estoque' : 'Adicionar Estoque'
  }
  const headerTitle = getHeaderTitle()

  const [activeMenu, setActiveMenu] = useState(0)
  const [updateInOmie, setUpdateInOmie] = useState<boolean>(false)
  const [updateInContaAzul, setUpdateInContaAzul] = useState<boolean>(false)
  const [calculateLength, setCalculateLength] = useState<boolean>(false)
  const [calculateWeight, setCalculateWeight] = useState<boolean>(false)
  const [warningMessage, setWarningMessage] = useState<string>('')
  const ncmTexto = useNcmTextoPendente()
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [isClosing, setIsClosing] = useState<boolean>(false)

  const [externalFiles, setExternalFiles] = useState<boolean>(() => {
    return isFashion ? Boolean(stock.externalInvoiceUrl) : Boolean(stock.externalCertificateUrl || stock.externalInvoiceUrl)
  })
  const [uploadProgress, setUploadProgress] = useState<Record<string, number>>({})

  useEffect(() => {
    if (stock.externalInvoiceUrl || (!isFashion && stock.externalCertificateUrl)) {
      setExternalFiles(true)
    }
  }, [stock.externalInvoiceUrl, stock.externalCertificateUrl, isFashion])

  useEffect(() => {
    if (isFashion) {
      setStock(prev => ({
        ...prev,
        certificateId: undefined,
        certificateParam: undefined,
        externalCertificateUrl: undefined
      }))
    }
  }, [isFashion])

  useEffect(() => {
    setWarningMessage('')
  }, [stock, updateInOmie, calculateLength, calculateWeight])

  const fetchCertificates = async (limit: number, offset: number, search?: string) => {
    const params: any = {
      limit,
      offset,
    }
    if (search) {
      params.search = search
    }
    const response = await ApiService.get('/certificates/certificate', params)
    const items = response.data?.data || response.data || []
    return items.map((cert: any) => ({
      id: cert.id,
      name: cert.param || cert.heatNumber || `Certificado #${cert.id}`,
    }))
  }

  const fetchInvoices = async (limit: number, offset: number, search?: string) => {
    const params: any = {
      take: limit,
      skip: offset,
    }
    if (search) {
      params.search = search
    }
    const response = await ApiService.get('/fiscal/invoice', params)
    const items = response.data?.data || response.data || []
    return items.map((inv: any) => ({
      id: inv.id,
      name: inv.numeroNF ? `NF ${inv.numeroNF}` : `Nota Fiscal #${inv.id}`,
    }))
  }

  const handleUploadFile = async (file: File, type: 'invoice' | 'certificate' | 'general') => {
    const fileId = `${type}-${file.name}`
    setUploadProgress(prev => ({ ...prev, [fileId]: 0 }))

    try {
      setUploadProgress(prev => ({ ...prev, [fileId]: 50 }))
      const uploaded = await AttachmentApiService.upload(file)
      const fileUrl = uploaded?.fileUrl
      if (!fileUrl) throw new Error('Falha no upload')

      setUploadProgress(prev => ({ ...prev, [fileId]: 100 }))

      if (type === 'invoice') {
        setStock(prev => ({ ...prev, externalInvoiceUrl: fileUrl }))
      } else if (type === 'certificate') {
        setStock(prev => ({ ...prev, externalCertificateUrl: fileUrl }))
      } else {
        setStock(prev => {
          const current = prev.attachments || []
          if (current.some((c: any) => c.fileUrl === fileUrl)) return prev
          return {
            ...prev,
            attachments: [...current, { id: uploaded.id || Date.now() + Math.random(), title: file.name, fileUrl }]
          }
        })
      }
    } catch (err) {
      console.error('Erro no upload:', err)
      setWarningMessage(`Erro ao fazer upload do arquivo ${file.name}`)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setStock({
      ...stock,
      [name]: value,
    })
  }

  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target
    switch (name) {
      case 'omie': {
        const newValue = !updateInOmie
        setUpdateInOmie(newValue)
        setUpdateInContaAzul(newValue)
        break
      }
      case 'calcLength':
        if (calculateWeight) {
          setCalculateWeight(false)
        }
        setCalculateLength(!calculateLength)
        break
      case 'calcWeight':
        if (calculateLength) {
          setCalculateLength(false)
        }
        setCalculateWeight(!calculateWeight)
        break
      default:
        console.log('Caminho inesperado ao ativar um switch toggle')
        break
    }
  }

  const handleDropdownClick = (value: string, field: string) => {
    setStock({
      ...stock,
      [field]: value,
    })
    setActiveMenu(0)
  }

  const previousPage = () => {
    console.log('🔙 [THIRDPAGE] Voltando para segunda página');
    console.log('📋 [THIRDPAGE] Estado atual antes de voltar:', {
      code: stock.code,
      ncm: stock.ncm,
      trackingNumber: stock.trackingNumber,
      hasInvoiceFiles: Boolean(stock.externalInvoiceUrl || stock.invoiceId),
      hasCertificateFiles: Boolean(stock.externalCertificateUrl || stock.certificateId)
    });
    setModalSection('secondCustomAdd')
  }

  const handleSubmit = async () => {
    console.log('🚀 [FRONTEND] Iniciando handleSubmit na ThirdPage');

    const currentToken = token || localStorage.getItem('token')
    console.log('🔑 [FRONTEND] Token status:', {
      hasTokenFromContext: !!token,
      hasTokenFromStorage: !!localStorage.getItem('token'),
      tokenPreview: currentToken ? `${currentToken.substring(0, 30)}...` : 'sem token'
    });

    if (!currentToken) {
      console.error('❌ [FRONTEND] Nenhum token encontrado');
      setWarningMessage('Sessão expirada. Faça login novamente.')
      setTimeout(() => {
        localStorage.removeItem('token')
        window.location.href = '/'
      }, 2000)
      return
    }

    const validation = validateToken(currentToken)
    console.log('✅ [FRONTEND] Validação do token:', validation);

    if (validation.isExpired) {
      console.error('❌ [FRONTEND] Token expirado:', validation.message);
      setWarningMessage(`${validation.message}. Redirecionando para login...`)
      setTimeout(() => {
        localStorage.removeItem('token')
        window.location.href = '/'
      }, 2000)
      return
    }

    if (isCodeRequired && (!stock.code || !stock.code.toString().trim())) {
      setWarningMessage(`O campo "Código" é obrigatório!`)
      return
    }
    if (ncmTexto.bloquear()) {
      setWarningMessage(MENSAGEM_NCM_INEXISTENTE)
      return
    }
    if (isFashion && stock.color && !stock.pantoneCode) {
      setWarningMessage('Selecione um Pantone para a cor antes de salvar!')
      return
    }
    if (!isFashion && !isVariation && updateInOmie) {
      if (stock.ncm === '') {
        setWarningMessage(`O campo "NCM" é obrigatório para atualização na Omie!`)
        return
      }
      if (stock.trackingNumber === '') {
        setWarningMessage(`O campo "Número de Rastreamento" é obrigatório para atualização na Omie!`)
        return
      }
    }
    if (calculateLength && stock.lengthInMm !== '') {
      setWarningMessage(
        `O comprimento já está preenchido, ele não pode ser calculado!`,
      )
      return
    }
    if (calculateWeight && stock.totalWeight !== '') {
      setWarningMessage(
        `O peso já está preenchido, ele não pode ser calculado!`,
      )
      return
    }

    console.log('📦 [FRONTEND] Preparando FormData:', {
      itIsUpdate,
      stockId: stock.id,
      code: stock.code,
      hasInvoice: stock.invoice?.length > 0,
      hasCertificates: stock.certificates?.length > 0,
      stockFields: Object.keys(stock).filter(key => key !== 'invoice' && key !== 'certificates'),
      invoiceCount: stock.invoice?.length || 0,
      certificatesCount: stock.certificates?.length || 0
    })

    console.log('🔍 [FRONTEND-DEBUG] Análise completa do objeto stock:', {
      totalFields: Object.keys(stock).length,
      isUpdate: itIsUpdate,
      stockId: stock.id
    });

    const stockFields = Object.keys(stock).filter(key => key !== 'invoice' && key !== 'certificates');
    const filledFields = stockFields.filter(key => {
      const value = stock[key as keyof Stock];
      return value !== undefined && value !== null && value !== '' && (typeof value === 'number' ? value !== 0 : true);
    });
    const emptyFields = stockFields.filter(key => {
      const value = stock[key as keyof Stock];
      return value === undefined || value === null || value === '' || (typeof value === 'number' && value === 0);
    });

    console.log('📊 [FRONTEND-DEBUG] Campos preenchidos:', {
      count: filledFields.length,
      fields: filledFields
    });

    console.log('🚿 [FRONTEND-DEBUG] Campos vazios:', {
      count: emptyFields.length,
      fields: emptyFields
    });

    const updateSpecificFields = ['id', 'createdAt', 'updatedAt', 'createdByIdUser', 'updatedByIdUser', 'tenantId'];
    const presentUpdateFields = stockFields.filter(field => updateSpecificFields.includes(field));

    if (itIsUpdate) {
      console.log('🔄 [FRONTEND-DEBUG] MODO UPDATE - Comparando campos extras:');

      const emptyStock = {
        material: '',
        format: '',
        family: '',
        density: '',
      };

      const extraFields = stockFields.filter(field => !Object.prototype.hasOwnProperty.call(emptyStock, field));
      console.log('📍 [FRONTEND-DEBUG] Campos extras no UPDATE (não presentes no CREATE):');
      console.log('📍 [FRONTEND-DEBUG] Total de campos extras:', extraFields.length);
      console.log('📍 [FRONTEND-DEBUG] Campos extras:', extraFields);

      const extraFieldsValues = extraFields.reduce((acc, field) => {
        acc[field] = stock[field as keyof Stock];
        return acc;
      }, {} as any);

      console.log('📍 [FRONTEND-DEBUG] Valores dos campos extras:', extraFieldsValues);
    } else {
      console.log('➕ [FRONTEND-DEBUG] MODO CREATE - Objeto stock mais limpo');
    }

    setIsSaving(true)
    const formData = new FormData()

    console.log('🔧 [FRONTEND-DEBUG] Iniciando criação do FormData...');
    let addedFieldsCount = 0;
    const addedFields: string[] = [];
    const skippedFields: string[] = [];

    for (const key in stock) {
      if (
        Object.prototype.hasOwnProperty.call(stock, key) &&
        key !== 'invoice' &&
        key !== 'certificates' &&
        key !== 'suppliers' &&
        key !== 'prices' &&
        key !== 'quantities' &&
        key !== 'certificateId' &&
        key !== 'invoiceId' &&
        key !== 'externalCertificateUrl' &&
        key !== 'externalInvoiceUrl' &&
        key !== 'status'
      ) {
        const rawValue = stock[key as keyof Stock] as string
        const value = key === 'code' && rawValue
          ? (/^[\d\s]+$/.test(String(rawValue).trim()) ? String(rawValue).replace(/\s+/g, '') : String(rawValue).trim())
          : key === 'carrierCode' && rawValue
          ? String(rawValue).replace(/\D/g, '')
          : (rawValue === null || rawValue === undefined ? '' : rawValue)
        formData.append(key, value)
        if (key === 'stockStatus' && value) {
          formData.append('status', value)
        }
        addedFieldsCount++;
        addedFields.push(key);

        if (addedFieldsCount <= 10) {
          console.log(`🔢 [FRONTEND-DEBUG] Campo ${addedFieldsCount}: ${key} = ${typeof value === 'string' ? value.substring(0, 30) : value}...`);
        }
      } else {
        skippedFields.push(key);
      }
    }

    if (stock.suppliers && Array.isArray(stock.suppliers)) {
      stock.suppliers.forEach((sup) => {
        const id = typeof sup === 'object' && sup !== null ? sup.id : sup;
        formData.append('suppliers', String(id))
      })
    }

    if (stock.prices && Array.isArray(stock.prices)) {
      stock.prices.forEach((priceItem, index) => {
        formData.append(`prices[${index}][price]`, String(priceItem.price))
        formData.append(`prices[${index}][unitOfMeasurementId]`, String(priceItem.unitOfMeasurementId))
      })
    }

    if (stock.quantities && Array.isArray(stock.quantities)) {
      console.log('DEBUG FRONTEND CREATE - stock.quantities:', stock.quantities)
      stock.quantities.forEach((qtyItem, index) => {
        formData.append(`quantities[${index}][quantity]`, String(qtyItem.quantity))
        formData.append(`quantities[${index}][unitOfMeasurementId]`, String(qtyItem.unitOfMeasurementId))
        if (qtyItem.minQuantity != null) {
          formData.append(`quantities[${index}][minQuantity]`, String(qtyItem.minQuantity))
        }
        if (qtyItem.maxQuantity != null) {
          formData.append(`quantities[${index}][maxQuantity]`, String(qtyItem.maxQuantity))
        }
      })
    }

    console.log('📊 [FRONTEND-DEBUG] FormData - Resumo da criação:', {
      totalFieldsAdded: addedFieldsCount,
      addedFields: addedFields.length > 20 ? addedFields.slice(0, 20).concat(['...']) : addedFields,
      skippedFields,
      isUpdate: itIsUpdate,
      stockCertificateId: stock.certificateId,
      stockInvoiceId: stock.invoiceId
    });

    formData.append('certificateId', !isFashion && stock.certificateId ? String(stock.certificateId) : '')
    formData.append('invoiceId', stock.invoiceId ? String(stock.invoiceId) : '')
    console.log('📊 [FRONTEND-DEBUG] FormData appended in handleSubmit:', {
      certificateIdInFormData: formData.get('certificateId'),
      invoiceIdInFormData: formData.get('invoiceId')
    });
    formData.append('externalCertificateUrl', !isFashion ? (stock.externalCertificateUrl || '') : '')
    formData.append('externalInvoiceUrl', stock.externalInvoiceUrl || '')
    if (stock.attachments && Array.isArray(stock.attachments)) {
      let attachmentIndex = 0;
      stock.attachments.forEach((att: any) => {
        const url = att?.fileUrl || att?.filePath || att?.GeneralFile?.fileUrl || att?.GeneralFile?.filePath || (typeof att === 'string' ? att : null);
        const title = att?.title || att?.name || att?.originalName || att?.GeneralFile?.title || att?.GeneralFile?.name || '';
        const isSpecialAttachment = title === 'Nota Fiscal Externa' || title === 'Certificado Externo' || (stock.externalInvoiceUrl && url === stock.externalInvoiceUrl) || (stock.externalCertificateUrl && url === stock.externalCertificateUrl);
        if (url && typeof url === 'string' && !url.includes('[object Object]') && !url.startsWith('[object ') && !isSpecialAttachment) {
          formData.append(`attachments[${attachmentIndex}]`, url)
          attachmentIndex++;
        }
      })
    }

    if (itIsUpdate) stock.availableBalance = '0'

    const currentTokenFinal = token || localStorage.getItem('token')

    const baseEndpoint = isFashion ? '/backend/stock-fashion' : '/backend/stock'

    try {
      let shouldProceedDirectly = true
      let existingStockData: any = null

      console.log('[THIRDPAGE] Checando existência de code antes de salvar...')
      const codeCheckResp = await ApiService.post('/backend/stock/findProductByCode', { code: stock.code })
      const codeData = codeCheckResp?.data

      if (codeData && codeData.id) {

        if (isVariation) {
          setWarningMessage('Este código já existe! Use um código diferente para criar a variação.')
          setIsSaving(false)
          return
        }


        try {
          const stockResp = await ApiService.get(`/backend/stock/findProductById/${codeData.id}`)
          existingStockData = stockResp?.data
        } catch {

          existingStockData = { id: codeData.id }
        }

        if (existingStockData) {
          if (itIsUpdate && Number(existingStockData.id) === Number(stock.id)) {
            shouldProceedDirectly = true
          } else {
            shouldProceedDirectly = false
            setExistingProduct(existingStockData)
            setShowConfirmModal(true)
          }
        }
      }

      if (!shouldProceedDirectly) {
        setIsSaving(false)
        return
      }

      let response

      const headers: any = {
        'Update-in-omie': String(updateInOmie),
        'Update-in-conta-azul': String(updateInContaAzul),
        'Weight-calculate': String(calculateWeight),
        'Length-calculate': String(calculateLength),
      }

      const debugPayload = {
        id: stock.id,
        code: stock.code,
        quantity: stock.quantity,
        totalWeight: stock.totalWeight,
        lengthInMm: stock.lengthInMm,
        measurementUnit: stock.measurementUnit,
        isUpdate: itIsUpdate,
        isVariation,
        updateInOmie,
        updateInContaAzul,
        calculateWeight,
        calculateLength,
      }
      console.debug('[FRONTEND-DEBUG] Tentativa de envio de update stock:', debugPayload)

      if (itIsUpdate && !isVariation) {
        response = await ApiService.put(`${baseEndpoint}/${stock.id}`, formData, { headers })
      } else {
        response = await ApiService.post(baseEndpoint, formData, { headers })
      }

      console.log('✅ [FRONTEND] Resposta recebida com sucesso:', {
        status: response?.status,
        hasData: !!response?.data,
        responseType: typeof response?.data,
        data: response?.data,
      });

      const serverStockSnapshot = {
        quantity: response?.data?.data?.quantity ?? response?.data?.quantity,
        totalWeight: response?.data?.data?.totalWeight ?? response?.data?.totalWeight,
        lengthInMm: response?.data?.data?.lengthInMm ?? response?.data?.lengthInMm,
        measurementUnit: response?.data?.data?.measurementUnit ?? response?.data?.measurementUnit,
      }
      console.debug('[FRONTEND-DEBUG] Resposta de update stock (fields críticos):', serverStockSnapshot)

      const updatedData = response?.data?.data ?? response?.data
      if (updatedData) {
        console.debug('[FRONTEND] Atualizando stock local com dados do servidor (handleSubmit):', updatedData)
        setStock((prev) => ({
          ...prev,
          ...updatedData,
          color: updatedData.color || updatedData.ItemColor?.name || prev.color,
          itemColorId: updatedData.itemColorId ?? updatedData.ItemColor?.id ?? prev.itemColorId,
          pantoneCode: updatedData.pantoneCode || updatedData.ItemColor?.Pantone?.code || prev.pantoneCode,
          pantoneHex: updatedData.pantoneHex || updatedData.ItemColor?.Pantone?.hex || prev.pantoneHex,
        }))
      }

      const wasCodeEmpty = !stock.code || !stock.code.toString().trim()
      const finalCode = updatedData?.code || updatedData?.Code?.code

      if (!itIsUpdate && wasCodeEmpty && isFashionTenant && finalCode) {
        setFeedback({
          message: `Código não informado, criado automaticamente com: ${finalCode}`,
          isOpen: true,
          statusOk: true,
          timeout: 20000,
        })
      } else {
        const action = itIsUpdate ? 'atualizado' : isVariation ? 'criado como variação' : 'criado'
        setFeedback({ message: `Estoque ${action} com sucesso!`, isOpen: true, statusOk: true })
      }

      setRefresh((prev) => !prev)

      setIsClosing(true)
      setTimeout(() => {
        setModalActive(false)
        if (returnTo) {
          navigate(returnTo, { replace: true })
        }
      }, 1000)
    } catch (err: any) {
      console.error('❌ [FRONTEND] Erro na requisição:', {
        status: err.response?.status,
        statusText: err.response?.statusText,
        message: err.message,
        responseData: err.response?.data,
        config: {
          url: err.config?.url,
          method: err.config?.method,
          hasAuth: !!err.config?.headers?.Authorization,
          headers: Object.keys(err.config?.headers || {})
        }
      });

      if (err.response?.status === 401) {
        console.error('🚫 [FRONTEND] Erro 401 - Sessão expirada');
        setWarningMessage('Sessão expirada durante o salvamento. Redirecionando para login...')
        setTimeout(() => {
          localStorage.removeItem('token')
          window.location.href = '/'
        }, 2000)
      } else if (err.response?.status === 403) {
        console.error('🚫 [FRONTEND] Erro 403 - Acesso negado');
        setWarningMessage('Acesso negado. Verifique suas permissões.')
      } else if (err.response?.status === 422) {
        console.error('⚠️ [FRONTEND] Erro 422 - Validação');
        setWarningMessage(`Erro de validação: ${err.response?.data?.message || 'Dados inválidos'}`)
      } else if (err.response?.data?.message) {
        console.error('⚠️ [FRONTEND] Erro com mensagem do servidor:', err.response.data.message);
        setWarningMessage(err.response.data.message)
      } else {
        console.error('❌ [FRONTEND] Erro genérico:', err);
        setWarningMessage('Ocorreu um erro ao salvar o estoque. Tente novamente.')
      }
    } finally {
      setIsSaving(false)
    }
  }

  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [existingProduct, setExistingProduct] = useState<any | null>(null)

  const confirmUpdate = async () => {
    setShowConfirmModal(false)
    setIsSaving(true)
    try {
      const formData = new FormData()
      for (const key in stock) {
        if (
          Object.prototype.hasOwnProperty.call(stock, key) &&
          key !== 'invoice' &&
          key !== 'certificates' &&
          key !== 'suppliers' &&
          key !== 'prices' &&
          key !== 'quantities' &&
          key !== 'certificateId' &&
          key !== 'invoiceId' &&
          key !== 'externalCertificateUrl' &&
          key !== 'externalInvoiceUrl' &&
          key !== 'status'
        ) {
          const rawValue = stock[key as keyof Stock] as string
          const value = rawValue === null || rawValue === undefined ? '' : rawValue
          formData.append(key, value)
          if (key === 'stockStatus' && value) {
            formData.append('status', value)
          }
        }
      }

      if (stock.suppliers && Array.isArray(stock.suppliers)) {
        stock.suppliers.forEach((sup) => {
          const id = typeof sup === 'object' && sup !== null ? sup.id : sup;
          formData.append('suppliers', String(id))
        })
      }
      if (stock.prices && Array.isArray(stock.prices)) {
        stock.prices.forEach((priceItem, index) => {
          formData.append(`prices[${index}][price]`, String(priceItem.price))
          formData.append(`prices[${index}][unitOfMeasurementId]`, String(priceItem.unitOfMeasurementId))
        })
      }
      if (stock.quantities && Array.isArray(stock.quantities)) {
        console.log('DEBUG FRONTEND UPDATE - stock.quantities:', stock.quantities)
        stock.quantities.forEach((qtyItem, index) => {
          formData.append(`quantities[${index}][quantity]`, String(qtyItem.quantity))
          formData.append(`quantities[${index}][unitOfMeasurementId]`, String(qtyItem.unitOfMeasurementId))
          if (qtyItem.minQuantity != null) {
            formData.append(`quantities[${index}][minQuantity]`, String(qtyItem.minQuantity))
          }
          if (qtyItem.maxQuantity != null) {
            formData.append(`quantities[${index}][maxQuantity]`, String(qtyItem.maxQuantity))
          }
        })
      }
      console.log('📊 [FRONTEND-DEBUG] update -> stock state:', {
        stockCertificateId: stock.certificateId,
        stockInvoiceId: stock.invoiceId
      });
      formData.append('certificateId', !isFashion && stock.certificateId ? String(stock.certificateId) : '')
      formData.append('invoiceId', stock.invoiceId ? String(stock.invoiceId) : '')
      console.log('📊 [FRONTEND-DEBUG] FormData appended in confirmUpdate:', {
        certificateIdInFormData: formData.get('certificateId'),
        invoiceIdInFormData: formData.get('invoiceId')
      });
      formData.append('externalCertificateUrl', !isFashion ? (stock.externalCertificateUrl || '') : '')
      formData.append('externalInvoiceUrl', stock.externalInvoiceUrl || '')
      if (stock.attachments && Array.isArray(stock.attachments)) {
        let attachmentIndex = 0;
        stock.attachments.forEach((att: any) => {
          const url = att?.fileUrl || att?.filePath || att?.GeneralFile?.fileUrl || att?.GeneralFile?.filePath || (typeof att === 'string' ? att : null);
          const title = att?.title || att?.name || att?.originalName || att?.GeneralFile?.title || att?.GeneralFile?.name || '';
          const isSpecialAttachment = title === 'Nota Fiscal Externa' || title === 'Certificado Externo' || (stock.externalInvoiceUrl && url === stock.externalInvoiceUrl) || (stock.externalCertificateUrl && url === stock.externalCertificateUrl);
          if (url && typeof url === 'string' && !url.includes('[object Object]') && !url.startsWith('[object ') && !isSpecialAttachment) {
            formData.append(`attachments[${attachmentIndex}]`, url)
            attachmentIndex++;
          }
        })
      }

      const headers: any = {
        'Update-in-omie': String(updateInOmie),
        'Weight-calculate': String(calculateWeight),
        'Length-calculate': String(calculateLength),
      }

      const confirmEndpoint = isFashion ? '/backend/stock-fashion' : '/backend/stock'

      let response
      if (itIsUpdate && !isVariation) {
        response = await ApiService.put(`${confirmEndpoint}/${stock.id}`, formData, { headers })
      } else {
        response = await ApiService.post(confirmEndpoint, formData, { headers })
      }

      console.log('[THIRDPAGE][confirmUpdate] Resposta do servidor:', {
        status: response?.status,
        data: response?.data,
      })

      const updatedData = response?.data?.data ?? response?.data
      if (updatedData) {
        console.debug('[THIRDPAGE][confirmUpdate] Atualizando stock local com dados do servidor:', updatedData)
        setStock((prev) => ({
          ...prev,
          ...updatedData,
          color: updatedData.color || updatedData.ItemColor?.name || prev.color,
          itemColorId: updatedData.itemColorId ?? updatedData.ItemColor?.id ?? prev.itemColorId,
          pantoneCode: updatedData.pantoneCode || updatedData.ItemColor?.Pantone?.code || prev.pantoneCode,
          pantoneHex: updatedData.pantoneHex || updatedData.ItemColor?.Pantone?.hex || prev.pantoneHex,
        }))
      }

      setRefresh((prev) => !prev)
      setIsClosing(true)
      setTimeout(() => setModalActive(false), 1000)
    } catch (err: any) {
      console.error('[THIRDPAGE][confirmUpdate] Erro ao confirmar update:', err)
      setWarningMessage('Falha ao atualizar o estoque. Verifique o console para detalhes.')
    } finally {
      setIsSaving(false)
    }
  }

  const cancelUpdate = () => {
    setShowConfirmModal(false)
    setExistingProduct(null)
    setWarningMessage('Ação cancelada pelo usuário.')
  }

  const ProgressBar: React.FC<ProgressBar> = (props) => {
    const fillerStyles = {
      width: `${props.completion}%`,
    }

    return (
      <ProgressContainer>
        <ProgressFill style={fillerStyles} />
      </ProgressContainer>
    )
  }

  const WarningBox = () => {
    return (
      <WarningDiv>
        <WarningText>{warningMessage}</WarningText>
      </WarningDiv>
    )
  }

  const switches: string[] = ['omie']
  const switchesText: string[] = [
    'Atualizar produtos na Omie',
  ]
  const switchValues: boolean[] = [
    updateInOmie,
    calculateLength,
    calculateWeight,
  ]

  return (
    <>
      {isClosing && <LoadingComponent />}
      <Container>
        <HeaderDiv>
          <HeaderText>{headerTitle}</HeaderText>
          <CloseDiv onClick={handleCloseModal}>
            <CloseImg src={cross} alt='Close tab' />
          </CloseDiv>
        </HeaderDiv>
        <ProgressBarDiv>
          <ProgressBarCircle className='active' />
          <ProgressBarLine className='active' />
          <ProgressBarCircle className='active' />
          <ProgressBarLine className='active' />
          <ProgressBarCircle className='active' />
        </ProgressBarDiv>

        <InputRowDiv>
          <InputDiv>
            <InputLabel htmlFor="code">
              Código
              {isCodeRequired && (
                <Info
                  size={15}
                  style={{ marginLeft: 5 }}
                  color={!stock.code ? 'red' : 'gray'}
                />
              )}
            </InputLabel>
            <div style={{ width: '25.5vw', marginTop: '0.8vh' }}>
              <InfiniteSelect
                inputStyle={{
                  height: '5.3vh',
                  borderRadius: '2vw',
                  boxSizing: 'border-box'
                }}
                mode="crud"
                allowFreeText={true}
                value={stock.code ? { id: stock.code, name: stock.code } : null}
                onSelect={(option) => setStock(prev => ({ ...prev, code: option ? (/^[\d\s]+$/.test(String(option.name).trim()) ? String(option.name).replace(/\s+/g, '') : String(option.name).trim()) : '' }))}
                canCreate={(name: string) => Boolean(name && name.trim().length > 0)}
                fetchFunction={async (limit, offset, search?) => {
                  const response = await ApiService.get('/backend/code', { type: 'stock' })
                  const items = Array.isArray(response?.data) ? response.data : []
                  const mapped = items.map((c: any) => {
                    if (typeof c === 'string') return { id: c, name: c }
                    return { id: c.id || c.code, name: c.code || '' }
                  })
                  return search
                    ? mapped.filter((item: any) => item.name?.toLowerCase().includes(search.toLowerCase()))
                    : mapped
                }}
                onItemCreate={async (name: string) => {
                  const trimmed = name.trim()
                  const cleaned = /^[\d\s]+$/.test(trimmed) ? trimmed.replace(/\s+/g, '') : trimmed
                  setStock(prev => ({ ...prev, code: cleaned }))
                  return { id: cleaned, name: cleaned } as any
                }}
                onItemDelete={async (code: any) => {
                  await ApiService.code.delete(code)
                }}
                placeholder="Buscar ou criar Código"
                allowCreate={true}
                allowDelete={true}
                showCreateOnlyIfNotExists={true}
                minCreateLength={2}
              />
            </div>
          </InputDiv>

          <InputDiv>
            <InputLabel htmlFor="ncm">
              NCM
              {!isFashion && updateInOmie && (
                <Info
                  size={15}
                  style={{ marginLeft: 5 }}
                  color={!stock.ncm ? 'red' : 'gray'}
                />
              )}
            </InputLabel>
            <div style={{ width: '25.5vw', marginTop: '0.8vh' }} onInput={ncmTexto.aoDigitar} onBlur={ncmTexto.aoSair}>
              <InfiniteSelect
                inputStyle={{
                  height: '5.3vh',
                  borderRadius: '2vw',
                  boxSizing: 'border-box'
                }}
                mode="crud"
                value={getSelectValue(stock.ncmId, stock.ncm)}
                onSelect={handleSelectNcm}
                endpointConfig={{
                  listPath: '/backend/ncm/catalogo',
                  searchParam: 'q',
                  transformResponse: (data: any) => (Array.isArray(data) ? data : []).map((item: any) => ({
                    id: item.id,
                    name: `${item.ncm}${item.descricao ? ` · ${item.descricao}` : ''}${item.jaCadastrado ? ' · em uso' : ''}`,
                    ncm: item.ncm,
                    descricao: item.descricao,
                    jaCadastrado: item.jaCadastrado,
                  })),
                }}
                placeholder="Buscar NCM"
                emptyOptionsMessage="Nenhum item disponível"
                errorOptionsMessage={MENSAGEM_NCM_INEXISTENTE}
                allowCreate={false}
                allowDelete={false}
              />
              <NcmErroCampo visivel={ncmTexto.exibirErro} />
            </div>
          </InputDiv>
        </InputRowDiv>

        <InputRowDiv style={{ marginBottom: '3vh' }}>
          <InputDiv>
            <InputLabel htmlFor="trackingNumber">
              Número de Rastreamento
              {!isFashion && updateInOmie && (
                <Info
                  size={15}
                  style={{ marginLeft: 5 }}
                  color={!stock.trackingNumber ? 'red' : 'gray'}
                />
              )}
            </InputLabel>
            <div style={{ width: '25.5vw', marginTop: '0.8vh' }}>
              <InfiniteSelect
                inputStyle={{
                  height: '5.3vh',
                  borderRadius: '2vw',
                  boxSizing: 'border-box'
                }}
                mode="crud"
                value={getSelectValue(stock.trackingNumberId, stock.trackingNumber)}
                onSelect={(option) => handleSelectChange(option, 'trackingNumberId', 'trackingNumber')}
                fetchFunction={async (limit, offset, search?) => {
                  const response = await ApiService.get('/backend/trackingNumber/list')
                  const items = Array.isArray(response?.data) ? response.data : []
                  return search
                    ? items.filter((item: any) => item.name?.toLowerCase().includes(search.toLowerCase()))
                    : items
                }}
                onItemCreate={async (name: string) => {
                  const response = await ApiService.post('/backend/trackingNumber', { number: name.trim() })
                  return { id: response.data.id, name: response.data.number || '' }
                }}
                onItemDelete={async (id: number) => {
                  await ApiService.delete(`/backend/trackingNumber/${id}`)
                }}
                placeholder="Buscar ou criar Número de Rastreamento"
                allowCreate={true}
                allowDelete={true}
                showCreateOnlyIfNotExists={true}
                minCreateLength={2}
              />
            </div>
          </InputDiv>

          <InputDiv>
            <InputLabel htmlFor="purchaseOrder">
              Ordem de Compra
            </InputLabel>
            <Input
              key="purchaseOrder"
              placeholder='Digite aqui'
              name="purchaseOrder"
              value={stock.purchaseOrder || ''}
              onFocus={() => setActiveMenu(5)}
              onBlur={() => {
                setTimeout(() => {
                  setActiveMenu(0)
                }, 200)
              }}
              onChange={handleChange}
              autoComplete='off'
            />
            {activeMenu === 5 ? (
              <StockDropdown
                key="dropdown-purchase"
                text={stock.purchaseOrder}
                field="purchaseOrder"
                onChange={(value) => {
                  handleDropdownClick(value, 'purchaseOrder')
                }}
              />
            ) : null}
          </InputDiv>
        </InputRowDiv>

        <SwitchesDiv>
          {switches.map((field, index) => {
            if (isFashion && field === 'omie') return null
            return (
              <SwitchDiv key={field}>
                <SwitchLabel htmlFor={field}>{switchesText[index]}</SwitchLabel>
                <SwitchBox>
                  <SwitchInput
                    type='checkbox'
                    name={field}
                    checked={switchValues[index]}
                    onChange={handleSwitchToggle}
                  />
                  <SwitchSlider className='slider'></SwitchSlider>
                </SwitchBox>
              </SwitchDiv>
            )
          })}
          <SwitchDiv>
            <SwitchLabel htmlFor="externalFiles">{isFashion ? 'Nota fiscal externa' : 'Nota fiscal e certificado externos'}</SwitchLabel>
            <SwitchBox>
              <SwitchInput
                type='checkbox'
                id="externalFiles"
                name="externalFiles"
                checked={externalFiles}
                onChange={(e) => {
                  const val = e.target.checked
                  setExternalFiles(val)
                  if (val) {
                    setStock(prev => ({
                      ...prev,
                      certificateId: undefined,
                      invoiceId: undefined,
                      certificateParam: undefined,
                      invoiceParam: undefined
                    }))
                  } else {
                    setStock(prev => ({
                      ...prev,
                      externalCertificateUrl: undefined,
                      externalInvoiceUrl: undefined
                    }))
                  }
                }}
              />
              <SwitchSlider className='slider'></SwitchSlider>
            </SwitchBox>
          </SwitchDiv>
        </SwitchesDiv>

        {externalFiles ? (
          <FilesDiv style={isFashion ? { justifyContent: 'flex-start' } : undefined}>
            <FileBlockDiv style={isFashion ? { width: '100%' } : undefined}>
              <FileHeaderText>Nota fiscal externa</FileHeaderText>
              {!stock.externalInvoiceUrl ? (
                <FileInputDiv style={isFashion ? { alignItems: 'center' } : undefined}>
                  <FileInputLabel
                    htmlFor={undefined}
                    onClick={(e) => {
                      e.preventDefault()
                      handleOpenSourceChoice('invoice')
                    }}
                    style={isFashion ? { marginLeft: 0, cursor: 'pointer' } : { cursor: 'pointer' }}
                  >
                    Procurar
                  </FileInputLabel>
                  <FileInput
                    ref={invoiceInputRef}
                    type='file'
                    id='invoice'
                    name='invoice'
                    accept='.pdf'
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                      const file = e.target.files?.[0]
                      if (file) handleUploadFile(file, 'invoice')
                      e.target.value = ''
                    }}
                  />
                  <FileFirstText style={isFashion ? { marginLeft: 0, textAlign: 'center' } : undefined}>
                    ou arraste um arquivo até aqui
                  </FileFirstText>
                  <FileSecondText style={isFashion ? { marginLeft: 0, textAlign: 'center' } : undefined}>
                    Apenas arquivos .pdf de no máximo 10mb
                  </FileSecondText>
                </FileInputDiv>
              ) : (
                <span>
                  <FilesInfoDiv style={isFashion ? { width: '100%' } : undefined}>
                    <FileInfoDiv style={isFashion ? { marginLeft: 0, width: '100%', maxWidth: '30vw' } : undefined}>
                      <FileInfoImg src={fileIcon} alt='File icon' />
                      <FileMiddleDiv>
                        <FileUpperMiddleDiv>
                          <FileName
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => openSignedAttachment(stock.externalInvoiceUrl!)}
                            title='Clique para visualizar o documento'
                          >
                            {stock.externalInvoiceUrl.split('/').pop() || 'nota-fiscal.pdf'}
                          </FileName>
                          <FilePercentage>
                            {uploadProgress[`invoice-${stock.externalInvoiceUrl.split('/').pop()}`] ?? 100}%
                          </FilePercentage>
                        </FileUpperMiddleDiv>
                        <ProgressBar completion={uploadProgress[`invoice-${stock.externalInvoiceUrl.split('/').pop()}`] ?? 100} />
                      </FileMiddleDiv>
                      <FileInfoCancelImg
                        src={cancelIcon}
                        alt='Cancel icon'
                        onClick={() => setStock(prev => ({ ...prev, externalInvoiceUrl: undefined }))}
                      />
                    </FileInfoDiv>
                  </FilesInfoDiv>
                </span>
              )}
            </FileBlockDiv>

            {!isFashion && (
              <FileBlockDiv>
                <FileHeaderText>Certificado externo</FileHeaderText>
                {!stock.externalCertificateUrl ? (
                  <FileInputDiv>
                    <FileInputLabel
                      htmlFor={undefined}
                      onClick={(e) => {
                        e.preventDefault()
                        handleOpenSourceChoice('certificate')
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      Procurar
                    </FileInputLabel>
                    <FileInput
                      ref={certificateInputRef}
                      type='file'
                      id='certificates'
                      name='certificates'
                      accept='.pdf'
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        const file = e.target.files?.[0]
                        if (file) handleUploadFile(file, 'certificate')
                        e.target.value = ''
                      }}
                    />
                    <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
                    <FileSecondText>
                      Apenas arquivos .pdf de no máximo 10mb
                    </FileSecondText>
                  </FileInputDiv>
                ) : (
                  <span>
                    <FilesInfoDiv>
                      <FileInfoDiv>
                        <FileInfoImg src={fileIcon} alt='File icon' />
                        <FileMiddleDiv>
                          <FileUpperMiddleDiv>
                            <FileName
                              style={{ cursor: 'pointer', textDecoration: 'underline' }}
                              onClick={() => openSignedAttachment(stock.externalCertificateUrl!)}
                              title='Clique para visualizar o documento'
                            >
                              {stock.externalCertificateUrl.split('/').pop() || 'certificado.pdf'}
                            </FileName>
                            <FilePercentage>
                              {uploadProgress[`certificate-${stock.externalCertificateUrl.split('/').pop()}`] ?? 100}%
                            </FilePercentage>
                          </FileUpperMiddleDiv>
                          <ProgressBar completion={uploadProgress[`certificate-${stock.externalCertificateUrl.split('/').pop()}`] ?? 100} />
                        </FileMiddleDiv>
                        <FileInfoCancelImg
                          src={cancelIcon}
                          alt='Cancel icon'
                          onClick={() => setStock(prev => ({ ...prev, externalCertificateUrl: undefined }))}
                        />
                      </FileInfoDiv>
                    </FilesInfoDiv>
                  </span>
                )}
              </FileBlockDiv>
            )}
          </FilesDiv>
        ) : (
          <InputRowDiv style={{ marginBottom: '3vh' }}>
            <InputDiv style={{ width: isFashion ? '53vw' : '25.5vw' }}>
              <InputLabel htmlFor="invoiceId">Nota Fiscal (Sistema)</InputLabel>
              <div style={{ marginTop: '0.8vh' }}>
                <InfiniteSelect
                  inputStyle={{
                    height: '5.3vh',
                    borderRadius: '2vw',
                    boxSizing: 'border-box'
                  }}
                  mode="crud"
                  value={stock.invoiceId ? { id: stock.invoiceId, name: stock.invoiceParam || `Nota Fiscal #${stock.invoiceId}` } : null}
                  onSelect={(option) => {
                    setStock(prev => ({
                      ...prev,
                      invoiceId: option ? option.id : undefined,
                      invoiceParam: option ? option.name : '',
                    }))
                  }}
                  fetchFunction={fetchInvoices}
                  placeholder="Selecione a Nota Fiscal"
                  showPantoneSwatch={false}
                />
              </div>
            </InputDiv>

            {!isFashion && (
              <InputDiv style={{ width: '25.5vw' }}>
                <InputLabel htmlFor="certificateId">Certificado de Qualidade (Sistema)</InputLabel>
                <div style={{ marginTop: '0.8vh' }}>
                  <InfiniteSelect
                    inputStyle={{
                      height: '5.3vh',
                      borderRadius: '2vw',
                      boxSizing: 'border-box'
                    }}
                    mode="crud"
                    value={stock.certificateId ? { id: stock.certificateId, name: stock.certificateParam || `Certificado #${stock.certificateId}` } : null}
                    onSelect={(option) => {
                      setStock(prev => ({
                        ...prev,
                        certificateId: option ? option.id : undefined,
                        certificateParam: option ? option.name : '',
                      }))
                    }}
                    fetchFunction={fetchCertificates}
                    placeholder="Selecione o Certificado"
                    showPantoneSwatch={false}
                  />
                </div>
              </InputDiv>
            )}
          </InputRowDiv>
        )}

        {/* Seção de Anexos Gerais removida */}
        <ButtonsDiv>
          <WarningBox />
          <PreviousButtonDiv onClick={previousPage}>
            <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
            <PreviousButtonText>Voltar</PreviousButtonText>
          </PreviousButtonDiv>
          <NextButtonDiv
            onClick={isSaving ? undefined : () => {
              handleSubmit()
            }}
            className={warningMessage !== '' || isSaving ? 'disabled' : ''}
          >
            {isSaving ? (
              <LoadingButtonContent />
            ) : (
              <>
                <NextButtonImage src={diskIcon} alt='Save icon' />
                <NextButtonText>Salvar</NextButtonText>
              </>
            )}
          </NextButtonDiv>
        </ButtonsDiv>
        {showConfirmModal && existingProduct && (
          <ConfirmationModal
            isOpen={showConfirmModal}
            title={'Código já existe — confirmar atualização'}
            message={(() => {
              const fieldsToCompare = [
                'code',
                'material',
                'format',
                'finishing',
                'fabrication',
                'heatTreatment',
                'ncm',
                'originCountry',
                'supplier',
                'stockStreet',
                'shelf',
                'stockLocation',
                'quantity',
                'totalWeight',
                'lengthInMm',
                'dimension1',
                'dimension2',
                'costPerKg',
                'costPerMm',
                'totalCost',
                'density',
                'receivedDate',
                'heatNumber',
                'family',
                'characteristic',
                'description',
                'purchaseOrder',
                'trackingNumber',
                'nf',
                'color',
                'measurementUnit',
              ] as string[]

              const getExisting = (f: string) => {
                if (!existingProduct) return ''
                if (f === 'code') return existingProduct?.code || existingProduct?.Code || (existingProduct?.code?.code) || ''
                if (f === 'material') return existingProduct?.material?.name || existingProduct?.material || existingProduct?.Material || ''
                if (f === 'color') return existingProduct?.color || existingProduct?.ItemColor?.name || existingProduct?.itemColor?.name || ''
                if (f === 'itemColorId') return existingProduct?.itemColorId || (existingProduct?.ItemColor?.id ?? '') || ''
                if (f === 'format') return existingProduct?.format?.type || existingProduct?.format || ''
                if (f === 'finishing') return existingProduct?.finishing?.type || existingProduct?.finishing || ''
                if (f === 'fabrication') return existingProduct?.fabrication?.type || existingProduct?.fabrication || ''
                if (f === 'heatTreatment') return existingProduct?.heatTreatment?.type || existingProduct?.heatTreatment || ''
                if (f === 'ncm') return existingProduct?.ncm?.ncm || existingProduct?.ncm || ''
                if (f === 'originCountry') return existingProduct?.originCountry?.countryName || existingProduct?.originCountry || ''
                if (f === 'supplier') return existingProduct?.supplier || ''
                if (f === 'stockStreet') return existingProduct?.stockStreet?.name || existingProduct?.stockStreet || ''
                if (f === 'shelf') return existingProduct?.shelf?.name || existingProduct?.shelf || ''
                if (f === 'stockLocation') return existingProduct?.stockLocation?.name || existingProduct?.stockLocation || ''
                if (f === 'heatNumber') return existingProduct?.heatNumber?.heatNumber || existingProduct?.heatNumber || ''
                if (f === 'family') return existingProduct?.family?.name || existingProduct?.family || ''
                if (f === 'measurementUnit') return existingProduct?.measurementUnit || existingProduct?.measurement_unit || ''
                if (f === 'density') return existingProduct?.density || existingProduct?.Material?.density || ''
                if (f === 'receivedDate') return existingProduct?.receivedDate || ''
                if (f === 'purchaseOrder') return existingProduct?.purchaseOrder || ''
                if (f === 'nf') return existingProduct?.nf || ''
                if (f === 'characteristic') return existingProduct?.characteristic || ''
                if (f === 'trackingNumber') return existingProduct?.trackingNumber || existingProduct?.tracking_number || ''
                if (f === 'description') return existingProduct?.description || ''
                return existingProduct?.[f] ?? ''
              }

              const numericFields = ['quantity', 'totalWeight', 'lengthInMm', 'dimension1', 'dimension2', 'costPerKg', 'costPerMm', 'totalCost', 'runNumber']

              const rows = fieldsToCompare
                .map((f) => {
                  const existingVal = getExisting(f)
                  const newValRaw = (stock as any)[f]
                  const newValStr = newValRaw === undefined || newValRaw === null ? '' : String(newValRaw)

                  let willChange = false
                  if (newValStr === '') {
                    willChange = false
                  } else if (numericFields.includes(f)) {
                    const eNum = Number(existingVal)
                    const nNum = Number(newValStr)
                    willChange = !(Number.isNaN(eNum) && Number.isNaN(nNum)) && eNum !== nNum
                  } else {
                    willChange = String(existingVal).trim() !== newValStr.trim()
                  }

                  if (!willChange) return null

                  const displayExisting = String(existingVal) === '' ? '-' : String(existingVal)
                  const displayNew = newValStr === '' ? displayExisting : newValStr

                  return (
                    <div key={f} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: '#fff8dc', borderRadius: 6, marginBottom: 6, alignItems: 'center' }}>
                      <div style={{ flex: 1, fontWeight: 700 }}>{(fieldsToHeaders as any)[f] || f}</div>
                      <div style={{ flex: 1, textAlign: 'left', color: '#666' }}>{displayExisting}</div>
                      <div style={{ flex: 1, textAlign: 'left', color: '#000', fontWeight: 600 }}>{displayNew}</div>
                    </div>
                  )
                })
                .filter(Boolean)

              return (
                <div style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: 8 }}>
                  <div style={{ marginBottom: 8 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, fontWeight: 700 }}>
                      <div>Campo</div>
                      <div>Atuais</div>
                      <div>Enviados</div>
                    </div>
                  </div>
                  <div style={{ display: 'grid', gap: 8 }}>
                    {rows.length > 0 ? rows : <div>Nenhum campo será alterado com os valores fornecidos.</div>}
                  </div>
                </div>
              )
            })()}
            actions={[
              { label: 'Cancelar', onClick: cancelUpdate, variant: 'outline' },
              { label: 'Confirmar atualização', onClick: confirmUpdate, variant: 'primary' },
            ]}
          />
        )}

        <AttachmentSourceModal
          isOpen={isSourceChoiceOpen}
          onClose={() => setIsSourceChoiceOpen(false)}
          title={
            pendingFileType === 'invoice'
              ? 'Adicionar Nota Fiscal Externa'
              : pendingFileType === 'certificate'
              ? 'Adicionar Certificado Externo'
              : 'Adicionar Anexos'
          }
          description='Escolha como deseja adicionar o documento:'
          onChooseUpload={() => {
            if (pendingFileType === 'invoice') {
              if (invoiceInputRef.current) {
                invoiceInputRef.current.click()
              } else {
                document.getElementById('invoice')?.click()
              }
            } else if (pendingFileType === 'certificate') {
              if (certificateInputRef.current) {
                certificateInputRef.current.click()
              } else {
                document.getElementById('certificates')?.click()
              }
            } else {
              if (generalInputRef.current) {
                generalInputRef.current.click()
              } else {
                document.getElementById('general-attachment-input')?.click()
              }
            }
          }}
          onChooseGallery={() => {
            setIsGalleryOpen(true)
          }}
        />

        <FileInput
          ref={generalInputRef}
          type='file'
          id='general-attachment-input'
          name='general-attachment-input'
          multiple
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            const files = e.target.files
            if (files && files.length > 0) {
              Array.from(files).forEach((f) => handleUploadFile(f, 'general'))
            }
            e.target.value = ''
          }}
        />

        <AttachmentGalleryModal
          isOpen={isGalleryOpen}
          onClose={() => setIsGalleryOpen(false)}
          multiple={pendingFileType === 'general'}
          defaultFilter={pendingFileType === 'invoice' || pendingFileType === 'certificate' ? 'pdf' : 'all'}
          title={
            pendingFileType === 'invoice'
              ? 'Galeria - Selecionar Nota Fiscal'
              : pendingFileType === 'certificate'
              ? 'Galeria - Selecionar Certificado'
              : 'Galeria - Selecionar Anexo'
          }
          onSelect={handleSelectFromGallery}
        />
      </Container>
    </>
  )
}

export default ThirdCustomAddPage
